import React from 'react';
import clsx from 'clsx';
import styles from './Text.module.css';

export type As = 'dt' | 'dd' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'legend' | 'p' | 'div';

type TextPropsBase = React.HTMLAttributes<HTMLElement> & {
	/**
	 * HTML Element to use in the component, to improve html semantic
	 * @default p
	 */
	as?: As;
	children?: React.ReactNode;
};

type TextPropsHeadline = TextPropsBase & {
	font: 'iberia-headline';
	size?:
		| 'xxl-regular'
		| 'xl-regular'
		| 'lg-regular'
		| 'lg-bold'
		| 'lg-italic'
		| 'md-regular'
		| 'md-bold'
		| 'sm-regular'
		| 'xs-regular'
		| 'xs-bold'
		| 'xs-italic'
		| 'xxs-regular'
		| 'xxs-bold'
		| 'xxs-italic'
		| 'xxs-regular-18';
};

type TextPropsVerdana = TextPropsBase & {
	font: 'verdana';
	size?:
		| 'lg-regular'
		| 'lg-enlace'
		| 'lg-regular-16'
		| 'lg-bold'
		| 'lg-italic'
		| 'md-regular'
		| 'md-italic'
		| 'md-bold'
		| 'md-enlace'
		| 'sm-regular'
		| 'sm-uppercase'
		| 'fare-name'
		| 'fare-price'
		| 'cabin-name'
		| 'cabin-price';
};

export type TextProps = TextPropsHeadline | TextPropsVerdana;

export const Text = React.forwardRef<HTMLElement, TextProps>(
	({ children, as = 'p', font, size, className, ...props }, ref) => {
		const Component = as;

		return (
			<Component
				ref={ref as React.Ref<HTMLLegendElement>}
				className={clsx(styles[font], size && styles[size], className)}
				{...props}
			>
				{children}
			</Component>
		);
	}
);
Text.displayName = 'TextDigital';
